import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { ChartBar, GameController, Trophy, GraduationCap } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function PublisherAnalytics() {
  const { publisherId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/api/publisher-portal/${publisherId}/analytics`, { withCredentials: true })
      .then(r => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [publisherId]);

  if (loading) return <div className="h-64 bg-white/5 rounded-lg animate-pulse" />;
  if (!data) return <p className="text-[#666]">Failed to load analytics.</p>;

  return (
    <div data-testid="publisher-analytics-page">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-white tracking-tight" style={{ fontFamily: 'Unbounded' }}>Analytics</h1>
        <p className="text-sm text-[#666] mt-1">Game performance and community engagement</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <div className="bg-[#0e0e16] border border-white/[0.06] rounded-lg p-4">
          <GameController size={20} weight="duotone" className="text-[#9D4CDD] mb-2" />
          <p className="text-2xl font-bold text-white">{data.games_count}</p>
          <p className="text-xs text-[#666]">Published Games</p>
        </div>
        <div className="bg-[#0e0e16] border border-white/[0.06] rounded-lg p-4">
          <ChartBar size={20} weight="duotone" className="text-[#00F0FF] mb-2" />
          <p className="text-2xl font-bold text-white">{data.total_game_sessions}</p>
          <p className="text-xs text-[#666]">Total Sessions</p>
        </div>
        <div className="bg-[#0e0e16] border border-white/[0.06] rounded-lg p-4">
          <Trophy size={20} weight="duotone" className="text-[#F59E0B] mb-2" />
          <p className="text-2xl font-bold text-white">{data.total_game_tournaments}</p>
          <p className="text-xs text-[#666]">Tournaments</p>
        </div>
        <div className="bg-[#0e0e16] border border-white/[0.06] rounded-lg p-4">
          <GraduationCap size={20} weight="duotone" className="text-[#10B981] mb-2" />
          <p className="text-2xl font-bold text-white">{data.total_tutorials}</p>
          <p className="text-xs text-[#666]">Tutorials</p>
        </div>
      </div>

      {data.game_names?.length > 0 && (
        <div className="bg-[#0e0e16] border border-white/[0.06] rounded-lg p-5">
          <h3 className="text-sm font-semibold text-white mb-3">Your Games</h3>
          <div className="flex flex-wrap gap-2">
            {data.game_names.map(name => (
              <span key={name} className="text-xs px-3 py-1.5 rounded-lg bg-[#F59E0B]/10 text-[#F59E0B] border border-[#F59E0B]/10">
                {name}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
